module.exports = __webpack_public_path__ + "img/info-icon.4312bc4b.svg";